import React, { useState } from "react";
import { EonUiLink, EonUiIcon, EonUiButton } from "@eon-ui/eon-ui-components-react";
import { EnvironmentConfig } from "@me8eon/config";
import { useTranslation } from "@me8eon/translation";
const API_BASE_URL = EnvironmentConfig.nodeService;
const SHARE_DATA_ENDPOINT = `${API_BASE_URL}/service/shareData`;
interface SharedPrefResponse {
  PrefData: string;
}

export const getSharedData = async (sharedId: string, apiKey: () => Promise<string | undefined>): Promise<unknown[]> => {
  try {
    const response = await fetch(`${SHARE_DATA_ENDPOINT}/${encodeURIComponent(sharedId)}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${await apiKey()}` },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch shared data: ${response.statusText}`);
    }

    const data: SharedPrefResponse = await response.json();
    return JSON.parse(data.PrefData);
  } catch (error) {
    console.error("Error in getSharedData:", error);
    throw error;
  }
};

// The share ID is generated by the backend — callers can no longer choose it. Returns the new ID.
export const setSharedData = async (
  sharedData: unknown[],
  apiKey: () => Promise<string | undefined>
): Promise<string> => {
  try {
    const response = await fetch(SHARE_DATA_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${await apiKey()}` },
      body: JSON.stringify({
        PrefData: JSON.stringify(sharedData),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to set shared data: ${response.statusText}`);
    }

    const data: { shareId: string } = await response.json();
    return data.shareId;
  } catch (error) {
    console.error("Error in setSharedData:", error);
    throw error;
  }
};

export const ShareDataComponent: React.FC<{ sharedId: string; onClose: () => void }> = ({ sharedId, onClose: handleCancel }) => {
  const t = useTranslation();
  const shareLink = `${window.location.origin}/tile/share?reqId=${sharedId}`;
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div>
      <div style={{ padding: "8px", borderRadius: "4px", boxShadow: "0 0 4px rgba(0,0,0,0.2)", }}>
        <strong style={{ wordBreak: "break-all" }}>{shareLink}</strong>
        <EonUiLink title="Copy Link" icon="copy" onClick={handleCopy} style={{ marginLeft: "8px", marginTop: "4px" }} />
      </div>
      <div style={{ textAlign: "center", margin: "8px" }}>
        <EonUiLink
          text="Share via Outlook"
          icon="notification_outline"
          href={`mailto:?subject=Shared Tile&body=${encodeURIComponent(shareLink)}`}
          target="_blank"
        />
      </div>
      {/* <EonUiLink
      text="Share via Teams"
      icon="chat"
      href={`https://teams.microsoft.com/l/chat/0/0?users=&message=${encodeURIComponent(shareUrl)}`}
      target="_blank"
      /> */}

      {
        copied && (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <EonUiIcon name="radio_checkbox_tick" style={{ color: "green" }} />
            {t("chatBot.copiedMsg")}
          </div>
        )
      }
      <EonUiButton
        fullWidthOnMobile
        text={t("cancel")}
        rank="secondary"
        size="small"
        onClick={() => handleCancel()}
      />
    </div>
  );
};